<ng-container *transloco="let t;">
<div class="modal-header">
    <h4 class="modal-title" id="myModalLabel1">{{t("Assign role modal text (Template/Document section) - Assign the missing role")}}</h4>
</div>
<div class="modal-body px-0" tabindex="0" ngbAutofocus>
    <div>
      <div class="customColumnsWrapper px-2 assign-role">
        <div class="row">
          <div class="col-md-6 col-sm-6 col-lg-6 border-right">
            <h6 class="mb-1">{{t("Assign role modal body text (Template/Document section) - Following fields do not match any role")}}</h6>
            <div class="reoderedColumnsWrapper"></div>
            <div class="sortColumnWrapper">
              <ng-container>
                @for(field of fields; track field){
                    <div class="sortColumnList py-75">
                        <div class="d-flex justify-content-between align-content-center">
                            <div class="sortColumnListText d-flex justify-content-start align-content-center" >
                            <span>
                                <i data-feather="alert-triangle" class="font-medium-1 me-1"></i>
                            </span>
                            <p class="mb-0">{{field.select_type_text}}</p>
                            </div>
                        </div>
                    </div>
                }
              </ng-container>
            </div>
          </div>
            <div class="col-md-6 col-sm-6 col-lg-6">
                <div class="col-md-12 col-lg-12 col-sm-12 mb-2">
                    <div class="form-group px-1">
                        <label class="col-form-label pt-0" for="name">{{t("Assign role modal text (Template/Document section) - Roles")}}</label>
                        <ng-select [items]="generalPopoverSettings.selectRole" bindLabel="name" bindValue="id" [(ngModel)]="selectedRole" [searchable]="true" [placeholder]='t("Field settings Select role - placeholder (Template/Document - section) - Select role")' [clearable]="false"></ng-select>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="modal.close()" rippleEffect>
        {{ t('Cancel button (custom columns modal) - Cancel') }}
    </button>
    <button type="button" class="btn btn-success" rippleEffect (click)="assignTheSelectedRole()">
        {{t("Assign role modal button text (Template/Document section) - Assign")}}
    </button>
</div>
</ng-container>